export default __webpack_public_path__ + "static/0089-7f4717e6c82c5c6d7a0b640e73dcc421.png";